/**
 * Marathi and Hindi text of every WhatsApp template, without the footer (the registry adds the
 * footer in the language of the message). The placeholders are the same as the English text; a test
 * checks it. Written without a native review: see docs/BACKLOG.md.
 */
export const LOCALES = {
    team_invite: {
        mr: '{{agency}}: {{inviter}} यांनी तुम्हाला {{app}} वर त्यांच्या टीममध्ये सामील होण्यासाठी बोलावले आहे. स्वीकारण्यासाठी ही लिंक उघडा: {{link}}',
        hi: '{{agency}}: {{inviter}} ने आपको {{app}} पर अपनी टीम से जुड़ने के लिए बुलाया है। स्वीकार करने के लिए यह लिंक खोलें: {{link}}',
    },
    visit_request_received: {
        mr: '{{agency}}: {{property}} साठी तुमची भेटीची विनंती मिळाली ({{slot}}). हा तुम्हीच आहात हे पक्के करण्यासाठी टॅप करा: {{link}}',
        hi: '{{agency}}: {{property}} के लिए आपकी विज़िट की रिक्वेस्ट मिली ({{slot}})। यह आप ही हैं, यह पक्का करने के लिए टैप करें: {{link}}',
    },
    renewal_reminder_tenant: {
        mr: '{{agency}}: {{property}} चा तुमचा भाडेकरार {{date}} रोजी संपतो. नूतनीकरणाबद्दल आमच्याशी बोला.',
        hi: '{{agency}}: {{property}} का आपका किराया एग्रीमेंट {{date}} को समाप्त होता है। नवीनीकरण के बारे में हमसे बात करें।',
    },
    renewal_reminder_owner: {
        mr: '{{agency}}: {{property}} चा भाडेकरार {{date}} रोजी संपतो. तुमच्या भाडेकरूसोबत नूतनीकरणाबद्दल आमच्याशी बोला.',
        hi: '{{agency}}: {{property}} का किराया एग्रीमेंट {{date}} को समाप्त होता है। अपने किरायेदार के साथ नवीनीकरण के बारे में हमसे बात करें।',
    },
    rent_reminder: {
        mr: '{{agency}}: {{property}} चे या महिन्याचे भाडे {{amount}}, दर महिन्याच्या {{day}} तारखेला देय आहे, याची आठवण. तुमच्या घरमालकांनी हे पाठवायला सांगितले आहे आणि ते कधीही थांबवू शकतात.',
        hi: '{{agency}}: {{property}} का इस महीने का किराया {{amount}}, हर महीने की {{day}} तारीख़ को देय है, इसकी याद। आपके मकान मालिक ने यह भेजने को कहा है और वे इसे कभी भी रोक सकते हैं।',
    },
    visit_confirmed: {
        mr: '{{agency}}: {{property}} ची तुमची भेट पक्की झाली ({{slot}}). पत्ता: {{address}}. नकाशा: {{map}} संपर्कासाठी {{phone}} वर कॉल करा.',
        hi: '{{agency}}: {{property}} की आपकी विज़िट पक्की हो गई ({{slot}})। पता: {{address}}। नक्शा: {{map}} संपर्क के लिए {{phone}} पर कॉल करें।',
    },
    visit_rescheduled: {
        mr: '{{agency}}: {{property}} ची तुमची भेट बदलली आहे ({{slot}}). पत्ता: {{address}}. नकाशा: {{map}} संपर्कासाठी {{phone}} वर कॉल करा.',
        hi: '{{agency}}: {{property}} की आपकी विज़िट बदल गई है ({{slot}})। पता: {{address}}। नक्शा: {{map}} संपर्क के लिए {{phone}} पर कॉल करें।',
    },
    visit_cancelled: {
        mr: '{{agency}}: {{property}} ची तुमची भेट रद्द झाली. दुसरी वेळ ठरवण्यासाठी {{phone}} वर कॉल करा.',
        hi: '{{agency}}: {{property}} की आपकी विज़िट रद्द हो गई। दूसरा समय तय करने के लिए {{phone}} पर कॉल करें।',
    },
    visit_done: {
        mr: '{{agency}}: {{property}} ची तुमची भेट झाल्याची नोंद झाली. ते घ्यायचे ठरवले तर पुढची पायरी टोकन आहे. पुढे जाण्यासाठी {{phone}} वर कॉल करा.',
        hi: '{{agency}}: {{property}} की आपकी विज़िट पूरी होने का रिकॉर्ड हुआ। लेने का तय करें तो अगला कदम टोकन है। आगे बढ़ने के लिए {{phone}} पर कॉल करें।',
    },
    visit_reminder_evening: {
        mr: '{{agency}}: आठवण: {{property}} ची तुमची भेट उद्या आहे ({{slot}}). पत्ता: {{address}}. नकाशा: {{map}} संपर्कासाठी {{phone}} वर कॉल करा.',
        hi: '{{agency}}: याद दिलाना: {{property}} की आपकी विज़िट कल है ({{slot}})। पता: {{address}}। नक्शा: {{map}} संपर्क के लिए {{phone}} पर कॉल करें।',
    },
    visit_reminder_2h: {
        mr: '{{agency}}: {{property}} ची तुमची भेट सुमारे दोन तासांनी आहे ({{slot}}). पत्ता: {{address}}. नकाशा: {{map}} संपर्कासाठी {{phone}} वर कॉल करा.',
        hi: '{{agency}}: {{property}} की आपकी विज़िट लगभग दो घंटे में है ({{slot}})। पता: {{address}}। नक्शा: {{map}} संपर्क के लिए {{phone}} पर कॉल करें।',
    },
    owner_intro: {
        mr: '{{agency}}: {{broker}} यांनी {{property}} साठी तुमचा नंबर जोडला आहे, भेटी आणि व्यवहाराची माहिती देण्यासाठी. हे चुकीचे असल्यास {{broker}} यांना सांगा.',
        hi: '{{agency}}: {{broker}} ने {{property}} के लिए आपका नंबर जोड़ा है, विज़िट और सौदे की जानकारी देने के लिए। यह ग़लत हो तो {{broker}} को बताएँ।',
    },
    owner_visit_request: {
        mr: '{{agency}}: एका क्लायंटने {{property}} पाहण्याची विनंती केली ({{slot}}). {{broker}} ती ठरवत आहेत.',
        hi: '{{agency}}: एक क्लाइंट ने {{property}} देखने की रिक्वेस्ट की ({{slot}})। {{broker}} इसे तय कर रहे हैं।',
    },
    owner_visit_done: {
        mr: '{{agency}}: {{property}} ची एक भेट झाली. पुढच्या पायरीबद्दल {{broker}} तुमच्याशी संपर्क करतील.',
        hi: '{{agency}}: {{property}} की एक विज़िट हो गई। अगले कदम के बारे में {{broker}} आपसे संपर्क करेंगे।',
    },
    owner_token_recorded: {
        mr: '{{agency}}: {{property}} साठी {{amount}} चे टोकन नोंदवले गेले. आता दलालीचा मेमो येईल.',
        hi: '{{agency}}: {{property}} के लिए {{amount}} का टोकन दर्ज हुआ। अब ब्रोकरेज मेमो आएगा।',
    },
    owner_visit_confirmed: {
        mr: '{{agency}}: {{client}} यांची {{property}} ची भेट पक्की झाली ({{slot}}). {{broker}} ती ठरवत आहेत.',
        hi: '{{agency}}: {{client}} की {{property}} की विज़िट पक्की हो गई ({{slot}})। {{broker}} इसे तय कर रहे हैं।',
    },
    owner_visit_moved: {
        mr: '{{agency}}: {{client}} यांची {{property}} ची भेट बदलली आहे ({{slot}}). {{broker}} ती ठरवत आहेत.',
        hi: '{{agency}}: {{client}} की {{property}} की विज़िट बदल गई है ({{slot}})। {{broker}} इसे तय कर रहे हैं।',
    },
    owner_visit_cancelled: {
        mr: '{{agency}}: {{client}} यांची {{property}} ची भेट ({{slot}}) रद्द झाली. प्रश्न असल्यास {{broker}} यांच्याशी बोला.',
        hi: '{{agency}}: {{client}} की {{property}} की विज़िट ({{slot}}) रद्द हो गई। सवाल हों तो {{broker}} से बात करें।',
    },
    owner_deal_registered: {
        mr: '{{agency}}: {{property}} चा भाडेकरार {{date}} रोजी नोंदवला गेला. करारनामा, नोंदणीची प्रत आणि महत्त्वाच्या तारखा इथे आहेत: {{link}}',
        hi: '{{agency}}: {{property}} का किराया एग्रीमेंट {{date}} को रजिस्टर हुआ। एग्रीमेंट, रजिस्ट्रेशन कॉपी और मुख्य तारीख़ें यहाँ हैं: {{link}}',
    },
    owner_deal_closed: {
        mr: '{{agency}}: {{property}} चा व्यवहार पूर्ण झाला. {{agency}} निवडल्याबद्दल धन्यवाद.',
        hi: '{{agency}}: {{property}} का सौदा पूरा हुआ। {{agency}} को चुनने के लिए धन्यवाद।',
    },
    owner_brokerage_receipt: {
        mr: '{{agency}}: {{property}} साठी तुमची {{amount}} दलाली {{date}} रोजी मिळाली. धन्यवाद.',
        hi: '{{agency}}: {{property}} के लिए आपका {{amount}} ब्रोकरेज {{date}} को मिला। धन्यवाद।',
    },
    deal_registered: {
        mr: '{{agency}}: {{property}} चा भाडेकरार {{date}} रोजी नोंदवला गेला. तुमचा करारनामा, नोंदणीची प्रत आणि महत्त्वाच्या तारखा इथे आहेत: {{link}}',
        hi: '{{agency}}: {{property}} का किराया एग्रीमेंट {{date}} को रजिस्टर हुआ। आपका एग्रीमेंट, रजिस्ट्रेशन कॉपी और मुख्य तारीख़ें यहाँ हैं: {{link}}',
    },
    deal_closed: {
        mr: '{{agency}}: {{property}} चा तुमचा व्यवहार पूर्ण झाला. {{agency}} निवडल्याबद्दल धन्यवाद.',
        hi: '{{agency}}: {{property}} का आपका सौदा पूरा हुआ। {{agency}} को चुनने के लिए धन्यवाद।',
    },
    memo_link: {
        mr: '{{agency}}: {{property}} चा दलालीचा मेमो वाचून सही करण्यासाठी तयार आहे. इथे उघडा: {{link}}',
        hi: '{{agency}}: {{property}} का ब्रोकरेज मेमो पढ़कर हस्ताक्षर के लिए तैयार है। यहाँ खोलें: {{link}}',
    },
    memo_link_updated: {
        mr: '{{agency}}: {{property}} चा दलालीचा मेमो बदलला आहे (आवृत्ती {{version}}). कृपया नवा वाचून सही करा: {{link}}',
        hi: '{{agency}}: {{property}} का ब्रोकरेज मेमो बदला गया है (संस्करण {{version}})। कृपया नया पढ़कर हस्ताक्षर करें: {{link}}',
    },
    memo_signed_copy: {
        mr: '{{agency}}: {{property}} च्या दलालीच्या मेमोवर सर्वांनी सही केली आहे. तुमची सही केलेली प्रत इथे आहे: {{link}}',
        hi: '{{agency}}: {{property}} के ब्रोकरेज मेमो पर सभी ने हस्ताक्षर कर दिए हैं। आपकी हस्ताक्षरित कॉपी यहाँ है: {{link}}',
    },
    brokerage_due: {
        mr: '{{agency}}: {{property}} च्या दलालीतील तुमचा वाटा {{amount}} आहे{{due}} याची आठवण. प्रश्न असल्यास {{phone}} वर कॉल करा.',
        hi: '{{agency}}: {{property}} के ब्रोकरेज में आपका हिस्सा {{amount}} है{{due}}, इसकी याद। सवाल हों तो {{phone}} पर कॉल करें।',
    },
    owner_brokerage_due: {
        mr: '{{agency}}: {{property}} च्या दलालीतील तुमचा वाटा {{amount}} आहे{{due}} याची आठवण. प्रश्न असल्यास {{phone}} वर कॉल करा.',
        hi: '{{agency}}: {{property}} के ब्रोकरेज में आपका हिस्सा {{amount}} है{{due}}, इसकी याद। सवाल हों तो {{phone}} पर कॉल करें।',
    },
    owner_memo_link: {
        mr: '{{agency}}: {{property}} चा दलालीचा मेमो वाचून सही करण्यासाठी तयार आहे. इथे उघडा: {{link}}',
        hi: '{{agency}}: {{property}} का ब्रोकरेज मेमो पढ़कर हस्ताक्षर के लिए तैयार है। यहाँ खोलें: {{link}}',
    },
    owner_memo_link_updated: {
        mr: '{{agency}}: {{property}} चा दलालीचा मेमो बदलला आहे (आवृत्ती {{version}}). कृपया नवा वाचून सही करा: {{link}}',
        hi: '{{agency}}: {{property}} का ब्रोकरेज मेमो बदला गया है (संस्करण {{version}})। कृपया नया पढ़कर हस्ताक्षर करें: {{link}}',
    },
    owner_memo_signed_copy: {
        mr: '{{agency}}: {{property}} च्या दलालीच्या मेमोवर सर्वांनी सही केली आहे. तुमची सही केलेली प्रत इथे आहे: {{link}}',
        hi: '{{agency}}: {{property}} के ब्रोकरेज मेमो पर सभी ने हस्ताक्षर कर दिए हैं। आपकी हस्ताक्षरित कॉपी यहाँ है: {{link}}',
    },
};
/** The footer every message to a client or an owner ends with, so nobody is left wondering who sends it. */
export const FOOTERS = {
    en: {
        all: 'Powered by {{app}}, which keeps the record of your deal for {{agency}}. About: {{about}}',
        stop: 'Wrong number or stop: {{stop}}',
    },
    mr: {
        all: '{{app}} वर आधारित, जे {{agency}} साठी तुमच्या व्यवहाराची नोंद ठेवते. माहिती: {{about}}',
        stop: 'चुकीचा नंबर किंवा थांबवा: {{stop}}',
    },
    hi: {
        all: '{{app}} द्वारा संचालित, जो {{agency}} के लिए आपके सौदे का रिकॉर्ड रखता है। जानकारी: {{about}}',
        stop: 'ग़लत नंबर या बंद करें: {{stop}}',
    },
};
//# sourceMappingURL=whatsapp-locales.js.map